module.exports = __webpack_public_path__ + "img/oldCoin.251655dc.png";